import { Components, Theme } from '@mui/material';

export const MuiTableCell: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          borderColor: theme.palette.border.default,
        };
      }

      return {};
    },
    head: {
      overflowWrap: 'break-word',
    },
  },
};
